module.exports = __webpack_public_path__ + "static/img/Michael_Walters_mobile.c64026e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael_Walters_mobile.jpg
// module id = SyZu
// module chunks = 0